import { DatePicker, Space } from "antd";
import type { Dayjs } from "dayjs";
import { useCallback } from "react";
import { FormattedMessage } from "react-intl";

type DateRangeValue = { from: Dayjs | null; to: Dayjs | null };

type DateRangeFilterProps = {
  placeholder?: string;
  onChange: (values?: DateRangeValue) => void;
  value?: DateRangeValue;
};

export const DateRangeFilter = ({ value, onChange, placeholder }: DateRangeFilterProps) => {
  const from = value?.from ?? null;
  const to = value?.to ?? null;

  const handleChangeDateRange = useCallback(
    (from: Dayjs | null, to: Dayjs | null) => {
      if (!from && !to) {
        onChange(undefined);
      } else {
        onChange({ from, to });
      }
    },
    [onChange],
  );

  const onFromChangeHandler = (date: Dayjs | null) => {
    const nextTo = to && date && to.isBefore(date, "day") ? null : to;
    handleChangeDateRange(date, nextTo);
  };

  const onToChangeHandler = (date: Dayjs | null) => {
    const nextFrom = from && date && date.isBefore(from, "day") ? null : from;
    handleChangeDateRange(nextFrom, date);
  };

  return (
    <Space>
      {placeholder}
      <DatePicker value={from} onChange={onFromChangeHandler} disabledDate={(current) => !!to && !!current && current.isAfter(to, "day")} />
      <FormattedMessage id="to" />
      <DatePicker
        value={to}
        onChange={onToChangeHandler}
        disabledDate={(current) => !!from && !!current && current.isBefore(from, "day")}
      />
    </Space>
  );
};
